export { fetchPublisherData } from 'next-flight-server-reference-proxy-loader?id=0005c7096cbdd464bcbb5cf77aa06b701cd2033dc7&name=fetchPublisherData!'